// extracted by mini-css-extract-plugin
module.exports = {"star":"starRating_star___VMfM"};